import axios from 'axios'

import { API, env } from '@utils'

const baseConfig = {
  ...API.defaults,
  baseURL: env('REACT_APP_AI_BASE_URL'),
  // baseURL: "https://v2202503187605326384.powersrv.de:8001",
  headers: {
    ...API.defaults.headers,        // pull in all original headers
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*"
  },
  withCredentials: false,
  timeout: 2 * 60 * 1000
}

// 2. Create a second instance using exactly the same config
const AI_API = axios.create(baseConfig)

// 3. (Optional) Copy over the interceptors from API → newAPI
API.interceptors.request.handlers.forEach(h => AI_API.interceptors.request.use(h.fulfilled, h.rejected))

API.interceptors.response.handlers.forEach(h => AI_API.interceptors.response.use(h.fulfilled, h.rejected))

export { AI_API }
